module.exports = __webpack_public_path__ + "static/sm-2-15cbb9d803864fdfa646b0b34221f787.png";